import {
    addToChainAfter, replaceInChain
} from "@insite/client-framework/HandlerCreator";
import { chain, DispatchCompleteSignIn, RedirectToChangeCustomer } from "@insite/client-framework/Store/Context/Handlers/SignIn";

export const DoNothingOnSignIn: any = () => {
    console.log("Redirecting...");
};

addToChainAfter(chain, DispatchCompleteSignIn, DoNothingOnSignIn);

replaceInChain(
    chain,
    DoNothingOnSignIn,
    RedirectToChangeCustomer,
);